<template>
  <a-modal
    class="create-plan-modal"
    :title="`${form.id ? '编辑计划' : '新建计划'}`"
    :width="800"
    :visible="visible"
    ok-text="提交"
    @ok="handleOk"
    :confirmLoading="btnLoading"
    destroyOnClose
    @cancel="hideModal"
  >
    <a-tabs :activeKey="activeKey" destroyInactiveTabPane @change="changeTab">
      <a-tab-pane
        :key="tabList[0].key"
        :tab="tabList[0].tab"
        :disabled="currEvalInfo?.tag !== undefined && activeKey !== currEvalInfo?.tag"
      >
        <!-- 心理测评 -->
        <a-form-model
          ref="ruleForm"
          :labelCol="{ span: 3 }"
          :wrapperCol="{ span: 20 }"
          :model="form"
          :rules="evalRules"
        >
          <a-form-model-item label="标题" prop="name">
            <a-input v-model="form.name" placeholder="请输入标题" />
          </a-form-model-item>
          <a-form-model-item label="选择量表" prop="evaluationIds">
            <a-select
              mode="multiple"
              v-model="form.evaluationIds"
              :options="evalOptions"
              placeholder="请选择量表"
            />
          </a-form-model-item>
          <a-form-model-item label="测评时间" prop="dateRang">
            <a-range-picker
              v-model="form.dateRang"
              :disabledDate="(currentDate) => disabledEndDate(currentDate, form.dateRang)"
              style="width: 100%"
            />
          </a-form-model-item>
          <a-form-model-item label="测评范围" prop="gradeIds" class="scope-assessment">
            <j-multi-select-tag
              style="width: 48%; margin-right: 4%"
              placeholder="请选择年级"
              :isHasAll="true"
              v-model="form.gradeIds"
              dictCode="school_grade,grade_name,id,0=delete_flag order by sort_order"
              :allowClear="false"
              :isShowEmpty="false"
              @select="selectGrade"
            />
            <j-multi-select-tag
              style="width: 48%"
              placeholder="请选择班级"
              :isHasAll="true"
              v-model="form.classIds"
              :dictCode="
                'school_class,name,id,grade_id=' + (!form.gradeIds ? -1 : form.gradeIds)
              "
              :async="true"
              :disabled="!form.gradeIds"
              :isShowEmpty="false"
              @select="selectClass"
            />
          </a-form-model-item>
          <a-form-model-item label="测评方式" prop="evaluationMethod">
            <j-dict-select-tag
              v-model="form.evaluationMethod"
              placeholder="请选择测评方式"
              dictCode="evaluation_method"
            />
          </a-form-model-item>
        </a-form-model>
      </a-tab-pane>
      <a-tab-pane
        :key="tabList[1].key"
        :tab="tabList[1].tab"
        :disabled="currEvalInfo?.tag !== undefined && activeKey !== currEvalInfo?.tag"
      >
        <!-- 校园活动 -->
        <a-form-model
          ref="ruleForm"
          :labelCol="{ span: 3 }"
          :wrapperCol="{ span: 20 }"
          :model="form"
          :rules="activitieRules"
        >
          <a-form-model-item label="标题" prop="title">
            <a-input v-model="form.title" placeholder="请输入活动标题" />
          </a-form-model-item>
          <a-form-model-item label="活动时间" prop="dateRang">
            <a-range-picker v-model="form.dateRang" style="width: 100%" />
          </a-form-model-item>
          <a-form-model-item label="活动范围" prop="gradeIds">
            <j-dict-select-tag
              style="width: 49%; margin-right: 2%"
              placeholder="请选择年级"
              v-model="form.gradeIds"
              dictCode="school_grade,grade_name,id,0=delete_flag order by sort_order"
              :allowClear="false"
              :isShowEmpty="false"
            />
            <j-dict-select-tag
              style="width: 49%"
              placeholder="请选择班级"
              v-model="form.classIds"
              :dictCode="
                'school_class,name,id,grade_id=' + (!form.gradeIds ? -1 : form.gradeIds)
              "
              :async="true"
              :disabled="!form.gradeIds"
              :isShowEmpty="false"
            />
          </a-form-model-item>
          <a-form-model-item label="活动内容">
            <WangEditor
              v-model="form.content"
              :editorStyle="{ minHeight: '200px' }"
              style="margin: 2px; border: 1px solid #d9d9d9; border-radius: 4px; overflow: hidden"
            />
          </a-form-model-item>
        </a-form-model>
      </a-tab-pane>
    </a-tabs>
  </a-modal>
</template>

<script>
import moment from 'moment'
import { getAction, postAction, putAction } from '@api/manage'
import WangEditor from '@comp/WangEditor/index.vue'
import { isDateGreaterThanToday } from '@/utils/util'
import JMultiSelectTag from '@comp/dict/JMultiSelectTag.vue'
import { disabledEndDate } from '@/utils/date'

export default {
  name: 'CreatePlan',
  components: {
    JMultiSelectTag,
    WangEditor,
  },
  data() {
    return {
      visible: false,
      activeKey: '0',
      form: {},
      tabList: [
        {
          tab: '心理测评',
          key: '0',
        },
        {
          tab: '校园活动',
          key: '1',
        },
      ],
      evalRules: {
        name: [{ required: true, message: '请输入测评标题', trigger: 'change' }],
        evaluationIds: [{ required: true, message: '请选择量表', trigger: 'change' }],
        dateRang: [{ required: true, message: '请选择日期范围', trigger: 'change' }],
        gradeIds: [{ required: true, message: '请选择测评范围', trigger: 'change' }],
        evaluationMethod: [{ required: true, message: '请选择测评方式', trigger: 'change' }],
      },
      activitieRules: {
        title: [{ required: true, message: '请输入活动标题', trigger: 'change' }],
        dateRang: [{ required: true, message: '请选择日期范围', trigger: 'change' }],
        gradeIds: [{ required: true, message: '请选择年级班级', trigger: 'change' }],
      },
      currEvalInfo: {},
      evalOptions: [],
      allGradeIds: '',
      allClassIds: '',
      btnLoading: false,
    }
  },
  methods: {
    disabledEndDate,
    showModal(data) {
      this.getEvalOptions()
      this.visible = true
      if (!data) return
      this.currEvalInfo = data
      this.form = {
        ...data,
        dateRang: [data.beginDate, data.endDate],
        evaluationIds: data.evaluationIds?.split(','),
      }
      this.activeKey = String(data.tag)
    },
    selectGrade(data) {
      if (data.val === 'all') {
        this.$set(this.form, 'gradeIds', data.val)
        this.allGradeIds =
          data.dictOptions.length > 0 ? data.dictOptions.map((item) => item.id).join(',') : ''
      } else {
        this.allGradeIds = ''
      }
      this.$set(this.form, 'classIds', undefined)
    },
    selectClass(data) {
      if (data.val === 'all') {
        this.allClassIds =
          data.dictOptions.length > 0 ? data.dictOptions.map((item) => item.id).join(',') : ''
      } else {
        this.allClassIds = ''
      }
    },
    getEvalOptions() {
      getAction('/schoolEvaluation/list', { pageNo: 1, pageSize: 200 })
        .then((res) => {
          if (res.success) {
            this.evalOptions =
              res.result.records?.map((item) => ({
                value: item.id,
                label: item.name,
              })) || []
          }
        })
        .finally(() => {
          this.$set(this.tabPaneConfig[this.tabKey - 1], 'loading', false)
        })
    },
    hideModal() {
      this.visible = false
      this.form = {}
      this.currEvalInfo = {}
      this.activeKey = '0'
    },
    async handleOk() {
      console.log('this.$refs', this.$refs)
      this.$refs.ruleForm.validate(async (valid) => {
        if (!valid) return
        this.btnLoading = true
        const baseParams = {
          id: this.form?.id,
          beginDate: moment(this.form.dateRang[0]).format('YYYY-MM-DD'),
          endDate: moment(this.form.dateRang[1]).format('YYYY-MM-DD'),
          gradeIds: this.allGradeIds || this.form.gradeIds,
          classIds: this.allClassIds || this.form.classIds,
        }
        const status = !isDateGreaterThanToday(baseParams.endDate)
          ? 3
          : isDateGreaterThanToday(baseParams.beginDate)
          ? 0
          : this.currEvalInfo.status
        const finalParams =
          this.activeKey === '0'
            ? {
                ...baseParams,
                name: this.form.name,
                evaluationIds: this.form.evaluationIds.join(','),
                evaluationMethod: this.form.evaluationMethod,
              }
            : {
                ...baseParams,
                title: this.form.title,
                content: this.form.content,
              }
        const urlArr = ['/schoolEvaluationPlan', '/schoolActivityPlan']
        let res = {}
        if (Object.keys(this.currEvalInfo)?.length) {
          res = await putAction(`${urlArr[this.activeKey]}/edit`, { ...finalParams, status })
        } else {
          res = await postAction(`${urlArr[this.activeKey]}/add`, finalParams)
        }
        this.btnLoading = false
        if (res.success) {
          this.$message.success(res.message)
          this.$emit('refreshData', { ...this.form, ...finalParams, status })
          this.hideModal()
          return
        }
        this.$message.error(res.message)
      })
    },
    changeTab(key) {
      this.activeKey = key
      this.form = {}
    },
  },
}
</script>
<style scoped lang="less">
.scope-assessment {
  /deep/ .ant-select {
    max-height: 80px !important;
    overflow-y: auto !important;
  }
}
.create-plan-modal {
  /deep/ .ant-modal-header {
    border-bottom: none;
  }
  /deep/ .ant-modal-body {
    padding: 0 20px;
  }
  /deep/ .ant-modal-header {
    padding: 10px 24px;
  }
}
</style>
